/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
// import { createLoadingSelector, createErrorSelector } from '@a1/core';
import { processActions } from "../../reducer/processReducer";

import logoSplash from "../../images/logo_splash.png";

class ForgottenPassSuccess extends Component {
  componentDidMount() {
    const { process, forgottenPassResetResults } = this.props;

    if (!(process.forgottenPassNewPassResult && process.forgottenPassNewPassResult.isOk === true)) {
      // history.push('/passrecovery');
      window.location.href = "https://new.a1xploretv.bg/login";
      return false;
    }

    document.title = "Забравена парола - Finish - A1 Xplore TV GO";

    forgottenPassResetResults();
    return false;
  }

  render() {
    return (
      <div className="page page-confirm">
        <div className="header-bg" />

        <div className="container container--small">
          <div className="container-head">
            <img src={logoSplash} alt="" />
          </div>
          <div className="container-body">
            <h1 className="tag-title">Паролата е променена успешно!</h1>

            <div className="tag-content" style={{ marginTop: "40px" }}>
              {/* <a
                href="https://new.a1xploretv.bg/login"
                className="tag-btn tag-btn--active"
                style={{ color: 'white' }}
              >
                Вход
              </a> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    process: state.process,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    forgottenPassResetResults: () => dispatch(processActions.forgottenPassResetResults()),
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ForgottenPassSuccess);
